import { SELECT_DETAIL_VIEW_OWNER } from './ActionTypes';
export function setDetailViewOwner(ownerId) {
  return {
    type: SELECT_DETAIL_VIEW_OWNER,
    payload: ownerId
  };
}